const BASE_URL: any = {
    BA_API: process.env.REACT_APP_ENV === 'production' ? '//jxtopenapi.xueche.com' : '//jxtopenapi.58v5.cn',
    USER_API: process.env.REACT_APP_ENV === 'production' ? '//user.ksedt.com' : '////userjxedttest.58v5.cn',
    JXTCOMMON_API: process.env.REACT_APP_ENV === 'production' ? 'https://jxt-common.xueche.com' :  'https://jxt-common.58v5.cn',
}

export default BASE_URL 
